// extracted by mini-css-extract-plugin
export default {"login":"login_page_login__ZQIba"};